/**
 * @since 2025-02-19
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import DialogConfirmJobAction from "./DialogConfirmJobAction";

export default DialogConfirmJobAction;
